<template>
  <div class="card card-body">
    <div class="d-flex align-items-center">
      <div class="d-flex justify-content-center align-items-center dashboard-icon-wrapper">
        <i
          class="d-block dashboard-icon"
          :class="[`fa fa-${icon}`, `text-${type}`]"
        ></i>
      </div>

      <div class="ml-3">
        <div class="text-stat-text text-muted small">
          <span v-if="!routeTo">{{ $t(text) }}</span>
          <v-button
            v-else
            style-type="link"
            size="xs"
            :no-padding="true"
            :text="text"
            :route-to="routeTo"
          />
        </div>
        <div class="text-large" v-if="animated">
          <v-animated-number
            :value="statistic"
            :formatValue="(value) => (value.toFixed(0))"
            :duration="500"
          />
        </div>
        <div class="text-large" v-else>
          {{ statistic }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnimatedNumber from 'animated-number-vue';
import Button from '@/common/components/Button.vue';

export default {
  name: 'StatisticCard',
  components: {
    'v-button': Button,
    'v-animated-number': AnimatedNumber,
  },
  props: {
    text: {
      required: true,
      type: String,
    },
    type: {
      required: true,
      type: String,
    },
    icon: {
      required: true,
    },
    animated: {
      type: Boolean,
      default() {
        return true;
      },
    },
    statistic: {
      required: true,
    },
    routeTo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
};
</script>

<style scoped>
span.text-small {
  font-size: 14px;
}

.text-stat-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-icon {
  font-size: 2rem;
}

.dashboard-icon-wrapper {
  width: 50px;
}
</style>
